import React from "react";

function Iframe({ title, src }) {
  return (
    <div>
      <iframe
        title={title}
        src={src}
        frameBorder="0"
        className="giphy-embed"
        allowFullScreen
        loading="lazy"
      ></iframe>
    </div>
  );
}

export default Iframe;
